import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useNeedHelp } from "modules/helpChat";
import { useSelector } from "react-redux";
import {
  selectEnableAgencyWhiteLabelling,
  selectIsAgencyWhitelabellingSettingsLoaded,
} from "modules/settings/redux/selectors";
import { useStyles } from "./styles";

export const DiscoveryEmptyState = () => {
  const isAgencyWhitelabellingSettingsLoaded = useSelector(
    selectIsAgencyWhitelabellingSettingsLoaded,
  );
  const enableAgencyWhiteLabellingGlobal = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const { callApi } = useNeedHelp();
  const styles = useStyles();
  const { t } = useI18n(["event"]);

  return (
    <Card innerClassName={styles.cardInner}>
      <Typography variant="h3" className={styles.title}>
        {t("event:no.events.found")}
      </Typography>
      <Typography variant="body1" className={styles.subtitle}>
        {t("event:no.events.found.subtitle")}
      </Typography>
      {isAgencyWhitelabellingSettingsLoaded &&
        !enableAgencyWhiteLabellingGlobal && (
          <Button
            variant="primary"
            color="blue"
            size="md"
            className={styles.contactSupportButton}
            aria-label={t("event:contact.us")}
            onClick={() => callApi("showNewMessage")}
          >
            {t("event:contact.us")}
          </Button>
        )}
    </Card>
  );
};
